exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".questionnaire__description[data-v-289f9bb6]{margin-bottom:28px;font-family:Open Sans,sans-serif;font-size:18px;font-weight:400;line-height:1.35;color:#666}.questionnaire__spinner[data-v-289f9bb6]{width:80px;height:80px;margin:0 auto 36px;display:block}.auth-btn[data-v-289f9bb6]{max-width:300px;margin:41px auto 0;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-289f9bb6","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/questionnaire/Questionnaire.vue
// module id = d64ef1e12dd23c347108
// module chunks = 5